import { openPopup } from "./helpers/openPopup.js";

export async function autoplaySettings(scope, ctx) {
    const { scenes, hud } = ctx;

    hud.setPopupState();

    const popup = await openPopup(scope, scenes, "AutoPlaySettingsScene", {
        gamesLimit: 10,
        autoplayGamesMax: 100,
    });

    let chosen = 10;
    scope.on(popup.onChangeAutoplayGames, (value) => {
        chosen = value;
    });

    const result = await Promise.race([
        scope.wait(popup.onPressStart).then(() => "start"),
        scope.wait(popup.onPressClose).then(() => "close"),
    ]);

    if (result === "start" && chosen > 0) {
        ctx.autoplay = {
            remaining: chosen,
            total: chosen,
            isActive() { return this.remaining > 0; },
        };
        hud.setAutoplayActive(true);
        hud.setAutoplayCount(chosen);
        hud.setAutoplayState();
    }
}
